import { useEffect } from 'react'
import { SITE } from './site.js'

// Browser-tab title ("<page> | Boss Contractor Agency") and meta description,
// set per page. The home page passes no title and gets the brand tagline.
export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE.name}` : `${SITE.name} | ${SITE.tagline}`
    const text = description || SITE.description
    let meta = document.querySelector('meta[name="description"]')
    if (!meta) {
      meta = document.createElement('meta')
      meta.setAttribute('name', 'description')
      document.head.appendChild(meta)
    }
    meta.setAttribute('content', text)
  }, [title, description])
}
